import * as Types from '../../../graphql.generated';

export type GetUserNotificationsQueryVariables = Types.Exact<{
    params?: Types.Maybe<Types.NotificationFilters>;
}>;

export type GetUserNotificationsQuery = { __typename?: 'Query' } & {
    notifications?: Types.Maybe<
        Array<
            | ({ __typename?: 'NotificationResult' } & Pick<
                  Types.NotificationResult,
                  | 'link'
                  | 'title'
                  | 'description'
                  | 'type'
                  | 'id'
                  | 'icon'
                  | 'createdAt'
              >)
            | ({ __typename?: 'NotificationError' } & Pick<
                  Types.NotificationError,
                  'errorCode'
              >)
        >
    >;
};

export const GetUserNotificationsDocument = `
    query getUserNotifications($params: NotificationFilters) {
  notifications(params: $params) {
    ... on NotificationResult {
      link
      title
      description
      type
      id
      icon
      createdAt
    }
    ... on NotificationError {
      errorCode
    }
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        getUserNotifications(
            variables?: GetUserNotificationsQueryVariables,
            options?: C
        ): Promise<GetUserNotificationsQuery> {
            return requester<
                GetUserNotificationsQuery,
                GetUserNotificationsQueryVariables
            >(GetUserNotificationsDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
